import { useState, useEffect } from "react";
import { Gift, X, Clock } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

export default function TrialBanner() {
  const { user } = useAuth();
  const [daysLeft, setDaysLeft] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (user?.license_type === "trial" && user?.trial_end_date) {
      const endDate = new Date(user.trial_end_date);
      const now = new Date();
      const diffTime = endDate - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setDaysLeft(diffDays > 0 ? diffDays : 0);
    }
  }, [user]);

  // لا تعرض إذا ليس في تجربة مجانية أو تم إخفاءها
  if (user?.license_type !== "trial" || dismissed || daysLeft === null) {
    return null;
  }

  return (
    <div className={`relative py-2 px-4 text-center text-sm font-medium ${
      daysLeft <= 2 
        ? "bg-gradient-to-r from-red-600 to-red-500 text-white" 
        : "bg-gradient-to-r from-amber-500 to-orange-500 text-white"
    }`}>
      <div className="flex items-center justify-center gap-2">
        {daysLeft <= 2 ? (
          <Clock className="w-4 h-4 animate-pulse" />
        ) : (
          <Gift className="w-4 h-4" />
        )}
        <span>
          {daysLeft === 0 
            ? "انتهت تجربتك المجانية اليوم!"
            : daysLeft === 1 
              ? "يتبقى يوم واحد على انتهاء التجربة المجانية"
              : `تجربة مجانية - باقي ${daysLeft} أيام`
          }
        </span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="absolute left-2 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded transition-colors"
        aria-label="إغلاق"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
